<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_status === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6" class="pa-2">
        <div class="text-right ma-2">
          <v-btn x-large class="text-center grad-success-bg white--text mobile_btn" to="/faqsadd">คำถามใหม่</v-btn>
        </div>
        <div class="pa-2">
          <v-data-table :headers="header" :items="faq_list" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.title }}</td>
                <td>{{ dataDetail.item.updated_at }}</td>
                <td>
                  <v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch>
                </td>
                <td>
                  <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                    <v-icon>mdi-note-edit-outline</v-icon>
                  </v-btn>
                  <v-btn small height="42" @click="getDelete(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Faqs_page",
  data() {
    return {
      loading_page: false,
      alert_status: false,
      alert_delete: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'คำถาม',
          value: '',
          fixed: true,
          width: '500px'
        },
        {
          text: 'วันที่',
          value: '',
          fixed: true,
          width: '150px'
        },
        {
          text: 'สถานะ',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px'
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px'
        },
      ],
      data_list: [
        {
          id: 1,
          faqs_name: 'ยางรถยนต์ หมดอายุ',
          date: '99/99/9999',
          status: true,
        },
      ],
      faq_list: [],
    }
  },
  methods: {
    get_data() {
      this.loading_page = true
      HTTP.post('/manage-website/faqs/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.faq_list = res.data.object
            }
          })
    },
    getEdit(id) {
      this.$router.push('/faqsedit' + '/' + id)
    },
    changeStatus(id, status) {
      HTTP.post('/manage-website/faqs/status', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_status = true
          setTimeout(() => this.alert_status = false, 3000)
        }
      })
    },
    getDelete(id) {
      Swal.fire({
        title: 'คุณต้องการลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/faqs/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.get_data()
              this.alert_delete = true
              setTimeout(() => this.alert_delete = false, 3000)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.mobile_btn {
  width: 30%;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
